module.exports = __webpack_public_path__ + "img/full-slide-6.f6e4f5e7.jpg";